/* nylstudios — Apple-style motion v2. No per-frame scroll work: scroll effects are CSS scroll-driven animations. */
(function () {
  'use strict';
  var d = document, w = window, root = d.documentElement;
  w.NYL_MOTION = true;
  if (!root.classList.contains('js-motion')) return; // reduced motion, theme editor or old browser

  var sda = !!(w.CSS && CSS.supports && CSS.supports('animation-timeline: scroll()'));
  var $$ = function (s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); };
  var desk = w.matchMedia('(min-width: 981px)');

  /* ---------- fade / slide reveal ---------- */
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -6% 0px', threshold: 0.05 });

  function rv(el, type, delay) {
    if (!el || el.hasAttribute('data-rv')) return;
    el.setAttribute('data-rv', type || '');
    if (delay) el.style.setProperty('--d', Math.min(delay, 0.4).toFixed(2) + 's');
    io.observe(el);
  }
  function stagger(sel, type, step, base) {
    $$(sel).forEach(function (p) {
      Array.prototype.forEach.call(p.children, function (el, i) { rv(el, type, (base || 0) + i * (step || 0.06)); });
    });
  }

  var hero = d.getElementById('hero');
  if (hero) {
    rv(hero.querySelector('.himg') || hero.querySelector('.veil'), 'scale', 0);
    rv(hero.querySelector('h1'), '', 0.1);
    rv(hero.querySelector('.count'), '', 0.2);
    rv(hero.querySelector('.cta'), '', 0.3);
  }
  stagger('.head', '', 0.08);
  $$('.cards, .cgrid').forEach(function (g) {
    $$('.card', g).forEach(function (c, i) {
      rv(c.querySelector('.ph'), 'scale', i * 0.07);
      rv(c.querySelector('.meta'), 'fade', i * 0.07 + 0.1);
    });
  });
  $$('.panel').forEach(function (p, i) {
    var b = i * 0.1;
    rv(p.querySelector(':scope > .mono'), '', b);
    rv(p.querySelector('.pimg'), 'scale', b + 0.05);
    rv(p.querySelector('.ghost'), 'fade', b + 0.05);
    rv(p.querySelector('.row'), '', b + 0.1);
  });
  $$('.trust > div').forEach(function (t, i) {
    Array.prototype.forEach.call(t.children, function (c) { rv(c, '', i * 0.06); });
  });
  stagger('.ihero, .pol, .facts, .steps3, .timeline, .acct, .cartp', '', 0.06);
  stagger('.buy', '', 0.05, 0.05);
  rv(d.querySelector('.pdp .gal'), 'scale', 0);
  stagger('footer .fg', '', 0.06);
  rv(d.querySelector('footer .fbase'), 'fade', 0);

  /* ---------- sticky text reveal: split headline once ---------- */
  var manis = [];
  $$('.mani').forEach(function (m) {
    var h = m.querySelector('.big');
    if (!h) return;
    var wrap = m.closest('.shopify-section') || m.parentElement;
    if (!sda) { // no scroll-driven support: simple reveals instead
      rv(h, '', 0);
      $$('.page > div > .mono, .lines p', m).forEach(function (el, j) { rv(el, '', 0.1 + j * 0.08); });
      return;
    }
    var txt = h.textContent.trim();
    h.setAttribute('aria-label', txt);
    var out = d.createElement('span');
    out.setAttribute('aria-hidden', 'true');
    var chars = [];
    txt.split(/(\s+)/).forEach(function (tok) {
      if (!tok) return;
      if (/^\s+$/.test(tok)) { out.appendChild(d.createTextNode(' ')); return; }
      var word = d.createElement('span');
      word.className = 'mw';
      tok.split('').forEach(function (ch) {
        var c = d.createElement('span');
        c.className = 'mc';
        c.textContent = ch;
        word.appendChild(c);
        chars.push(c);
      });
      out.appendChild(word);
    });
    h.textContent = '';
    h.appendChild(out);
    var n = Math.max(1, chars.length - 1);
    chars.forEach(function (c, k) { c.style.setProperty('--p', (k / n).toFixed(3)); });
    $$('.page > div > .mono, .lines p', m).forEach(function (el, j) { el.style.setProperty('--j', j); });
    manis.push({ m: m, wrap: wrap });
  });

  /* ---------- layout (only on load / resize, never on scroll) ---------- */
  var heroWrap = hero && (hero.closest('.shopify-section') || hero.parentElement);
  var heroIsFirst = heroWrap && heroWrap === heroWrap.parentElement.firstElementChild;

  function layout() {
    var vh = w.innerHeight;
    if (heroWrap && heroIsFirst) {
      if (desk.matches) {
        heroWrap.classList.add('h-pin');
        heroWrap.style.top = Math.min(0, vh - heroWrap.offsetHeight) + 'px';
      } else {
        heroWrap.classList.remove('h-pin');
        heroWrap.style.top = '';
      }
    }
    manis.forEach(function (o) {
      o.wrap.classList.add('m-pin');
      if (o.m.offsetHeight > vh + 2) o.wrap.classList.remove('m-pin'); // too tall to pin
    });
  }

  var rt;
  function onResize() { clearTimeout(rt); rt = setTimeout(layout, 150); }
  layout();
  w.addEventListener('resize', onResize);
  w.addEventListener('load', layout);
  if (desk.addEventListener) desk.addEventListener('change', layout);
})();
